import { render, staticRenderFns } from "./ConsultaOrcamento.vue?vue&type=template&id=18edc7f2&"
import script from "./ConsultaOrcamento.vue?vue&type=script&lang=js&"
export * from "./ConsultaOrcamento.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaOrcamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports